import { jsx } from "react/jsx-runtime";
import { DecoratorNode } from "lexical";
import { Image } from "../../plugins/index.js";
import { $createSingleImageNode, $isSingleImageNode } from "./SingleImageNode.helpers.js";
class SingleImageNode extends DecoratorNode {
    getId() {
        return this.id;
    }
    decorate(editor) {
        return /*#__PURE__*/ jsx(Image, {
            alt: this.alt,
            id: this.id,
            description: this.description,
            mode: this.mode,
            editable: editor._editable
        });
    }
    static getType() {
        return 'single-image';
    }
    static clone(node) {
        return new SingleImageNode(node.alt, node.id, node.description, node.mode, node.__key);
    }
    createDOM() {
        const dom = document.createElement('span');
        dom.setAttribute('data-id', this.id);
        return dom;
    }
    updateDOM(prevNode, dom) {
        if (!$isSingleImageNode(prevNode)) return true;
        const propertiesChanged = this.id !== prevNode.id || this.alt !== prevNode.alt || this.description !== prevNode.description;
        if (this.id !== prevNode.id) dom.dataset.id = this.id;
        return propertiesChanged;
    }
    exportJSON() {
        return {
            type: 'single-image',
            version: 1,
            alt: this.alt,
            id: this.id,
            description: this.description,
            mode: this.mode,
            children: [],
            direction: null,
            format: '',
            indent: 0
        };
    }
    static importJSON(serializedNode) {
        return $createSingleImageNode(serializedNode.alt, serializedNode.id, serializedNode.description, serializedNode.mode);
    }
    getTextContent() {
        return this.description || '';
    }
    constructor(alt, id, description, mode, key){
        super(key);
        this.alt = alt;
        this.id = id;
        this.description = description;
        this.mode = mode;
    }
}
export { SingleImageNode };
